<script>
import AppIcon from '@/components/svg/AppIcon'
import Fade from '@/components/transitions/Fade'
import FadeSlideUp from '@/components/transitions/FadeSlideUp'

export default {
	components: { AppIcon, Fade, FadeSlideUp },
}
</script>

<template>
	<section class="relative">
		<Fade>
			<div class="bg-cream-200 absolute inset-0" />
		</Fade>
		<FadeSlideUp>
			<div class="relative flex flex-col items-center pt-32 pb-16 px-6">
				<AppIcon class="w-20 text-cream-600"/>
				<span
					class="font-inter text-cream-600 text-center text-xl uppercase font-semibold"
					style="letter-spacing: 2.73px; margin-top: 36px;"
				>Introducing</span>
				<h1 class="mt-6 flex flex-col items-center gap-1 text-center">
					<span
						class="font-inter font-medium text-black leading-tight"
						style="font-size: 50px;"
					>Owner</span>
					<span
						class="font-inter font-bold text-black leading-tight"
						style="font-size: 45px;"
					>Mobile App</span>
				</h1>
			</div>
		</FadeSlideUp>
	</section>
</template>
